<template>
  <v-container>
      <v-row
        justify="center"
        align="center"
      >
          <v-card
            flat
            tile
            class="cardPluris"
          >
            <v-row
              justify="center"
              class="rowMenu"
              no-gutters
            >
              <v-col
                cols="3"
              >
                <v-card class="cardImage transparent" flat>
                  <v-img
                    @click="callInitialPage()"
                    src="../assets/img/logo_v.svg"
                  />
                </v-card>

              <div v-bind:class="{ 'mt-10': $vuetify.breakpoint.lgAndUp }">

                <div v-for="index in 6" :key="index">
                <menu-pluris
                  :id="index"
                  @callPage="callPageCard"
                  :title="$t('menu.item' + index)"
                  :items="index == 1 || index == 3 ? $t('menu.items' + index) : []"
                />

                </div>
              </div>

              </v-col>

              <v-divider
                class="divider"
                vertical
                inset
              />

              <v-col
                cols="8"
                class="cardContent"
              >
                <div class="scrollbar">
                  <p class="titlePluris">{{ title }}</p>
                  <p
                    class="content mt-6"
                    v-if="content !== '' && idPluris !== 5 && idPluris !== 6"
                    v-html="$t(content)"
                  />
                  <p
                    class="content mt-6"
                    v-else-if="idPluris !== 5 && idPluris !== 6"
                  >
                    {{ $t("construction") }}
                  </p>

                  <!-- Organização -->
                  <v-row
                    justify="start"
                    no-gutters
                  >
                    <v-col
                      cols="7"
                      v-show="idIndex === 1 && idPluris === 1"
                    >
                      <br>
                      <p
                        class="content"
                      >
                        <b>{{ $t("content.items1[1].title1") }}</b>
                      </p>

                      <v-img
                        class="ma-1"
                        src="../assets/img/uminho_usp_ufscar.png"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      v-show="idIndex === 1 && idPluris === 1"
                    >
                      <br><br>
                      <p
                        class="content"
                      >
                        <b>{{ $t("content.items1[1].title2") }}</b>
                      </p>

                      <v-row
                        justify="start"
                        no-gutters
                        class="ma-1"
                      >
                        <v-col
                          cols="3"
                        >
                          <v-img
                            src="../assets/img/unesp.svg"
                          />
                        </v-col>

                        <v-col
                          cols="2"
                        >
                          <v-img
                            src="../assets/img/PPGARQ_h.png"
                          />
                        </v-col>

                        <v-col
                          cols="3"
                        >
                          <v-img
                            src="../assets/img/civil.png"
                          />
                        </v-col>

                        <v-col
                          cols="2"
                        >
                          <v-img
                            src="../assets/img/faac.jpg"
                          />
                        </v-col>

                        <v-col
                          cols="2"
                        >
                          <v-img
                            src="../assets/img/feb.jpg"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <p
                    class="content"
                    v-html="$t('content.items1[1].contentContinuation')"
                    v-show="idIndex === 1 && idPluris === 1"
                  />

                  <!-- Palestrantes -->
                  <div v-show="idIndex === 3 && idPluris === 1">
                  <table width="100%">
                    <tr class="tituloPalestra">
                      <th class="bold">PALESTRA MAGNA <br>
                      07/04/2021 - 10h</th>
                    </tr>
                  </table>

                <v-container>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: left"
                    class="bold"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>
                        Planning Support Science: past – present - future<br>
                        Stan Geertman<br>
                        Professor of Planning Support Science at Utrecht University,
                        the Netherlands
                      </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>In my contribution I would like to take you on a journey through time,
                         from Planning Support Systems (PSS) to Planning Support Science
                         (PSScience). Central in that is the notion of 'Planning Support': how did
                         we looked at this in the past, what constitute our present view, and what
                         ideas on developments and challenges do we possess for the future.
                         Furthermore, I would like to provide some real-world examples, in my
                         perspective best practices, as an inspiration.<br>
                      </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col align="center">
                    <v-img
                      src="../assets/img/stan_geertman.jpg"
                      width="160px"
                    />
                    </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        Currículo:
                        <br>Prof. Dr. Stan Geertman (1955) is Professor of Planning Support
                         Science at Utrecht University, the Netherlands. He has published widely
                         in both national and international journals and has published a range of
                         (editorial) books. He is a member of the editorial board of several
                         scientific journals, including CEUS (Computers, Environment, and Urban
                         Systems). He has been member and/or chair of several international
                         conference organizations (EGIS; JECC; AGILE-2011; DDSS; CUPUM-2013)
                         and was up till recently Chair of the international Board of Directors
                         of CUPUM (Computers in Urban Planning and Urban Management). He has
                         supervised a range of PhD students and Postdocs and participated in a
                         diversity of interdisciplinary
                         research projects, ranging from ‘Climate change and sustainable land use’
                         up till ‘Spatial economic deconcentration’ and ‘Floodlabel’. He has been
                         scientific director for 10 years of a spin-off of Utrecht University
                         (Nexpri) and was one of the founding fathers and first program director
                         of the inter-university (TUD, WUR, UU, ITC-UT) Master program GIMA
                         (Geographical Information Management and Applications). For two years he
                         was appointed scientific advisor of the Management Team of the
                         PGM-Department at ITC, Twente University. Since 2016 he is Chair of
                         Spatial Planning within the Department of Human Geography an Planning
                         of the Faculty of Geosciences at Utrecht University.
                        His research interest:
                        <ul>
                          <li>Planning Support Science (PSScience)</li>
                          <li>Smart Cities and Smart Governance</li>
                          <li>Sustainable urbanization, notably in Western and Chinese contexts</li>
                        </ul>
                        <br>
                      </v-col>
                  </v-row>
                </v-container>

                <table width="100%">
                  <tr class="tituloPalestra">
                    <th class="bold">PALESTRA MAGNA <br>
                    07/04/2021 – 11h15</th>
                  </tr>
                </table>

                <v-container>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: left"
                    class="bold"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>
                        Os desafios para aplicação da Nova Agenda Urbana
                        nas cidades brasileiras<br>
                        Daniel Todtmann Montandon<br>
                        Diretor de Arquitetura e Urbanismo na
                        Universidade Nove de Julho
                      </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>O Programa das Nações Unidas para os Assentamentos Humanos
                         - ONU Habitat - tem fortalecido a agenda mundial relacionada
                        ao desenvolvimento urbano sustentável. Além das grandes
                        conferências realizadas a cada 20 anos, tem realizado os Fóruns Urbanos
                        Mundiais a cada 2 anos e na Conferência Habitat III, realizada em Quito,
                        Equador, em outubro de 2016, instituiu a Nova Agenda Urbana, que consiste
                        na principal referência internacional de orientação para o
                        desenvolvimento urbano sustentável. Cabe, portanto, examinar o teor
                        desse documento e em que medida está sendo de fato implementado
                        pelas cidades brasileiras.
                      </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col align="center">
                    <v-img
                      src="../assets/img/daniel_todtmann.jpg"
                      width="170px"
                    />
                    </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        Currículo:
                        <br>Arquiteto pela Universidade Estadual Paulista, Unesp/Bauru (2001).
                         Mestre em Planejamento Urbano e Regional pela Faculdade de
                         Arquitetura e Urbanismo da Universidade de São Paulo - FAUUSP (2009).
                         Doutorando na mesma universidade, tendo iniciado em 2017. Foi Professor
                         de Urbanismo na Escola da Cidade de janeiro de 2013 a dezembro de 2020
                         e na Universidade São Judas Tadeu de agosto de 2018 a dezembro de 2019.
                         Foi Diretor de Planejamento Urbano no Ministério das Cidades
                         (2008 a 2011). Na Secretaria Municipal de Desenvolvimento Urbano da
                         Prefeitura da Cidade de São Paulo foi Diretor do Departamento de Uso
                         do Solo (2013 a 2016), Presidente da Comissão de Proteção à Paisagem
                         Urbana - CPPU (2013 a 2015), presidente da Câmara Técnica de Legislação
                         Urbanística - CTLU (2015 a 2016) e representante titular da secretaria
                         no Conselho Municipal de Política Urbana - CMPU (2015 a 2016). Foi
                         responsável pela coordenação da revisão da lei de zoneamento (Lei
                         16.402/16). Participou de diversos projetos de cooperação técnica
                         internacional sobre planejamento urbano com a Organização das
                         Nações Unidas (ONU), Aliança de Cidades, Agência de Cooperação
                         Internacional do Japão (JICA) e Lincoln Institute of Land Policy.
                         É autor, co-autor e organizador de publicações sobre instrumentos de
                         planejamento urbano e Estatuto da Cidade. Atualmente exerce a função
                         de Diretor de Arquitetura e Urbanismo na Universidade Nove de Julho.
                        <br><br>
                      </v-col>
                  </v-row>
                </v-container>

                <table width="100%">
                  <tr class="tituloPalestra">
                    <th class="bold">PALESTRA MAGNA <br>
                    08/04/2021 – 10h</th>
                  </tr>
                </table>

                <v-container>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: left"
                    class="bold"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>
                        Inequality in Transport
                        David Banister<br>
                        Emeritus Professor of Transport Studies at the School
                         of Geography and the Environment (SoGE) and the
                         Transport Studies Unit of University of Oxford
                      </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>Everyone needs transport to move around and to access everyday needs,
                        but for each individual those needs are different, and they change over
                        time and space: herein lie the seeds of inequalities in transport. This
                        complex problem will be explored, first through an understanding of
                        inequality, its nature, measurement and extent. The empirical part
                        of the presentation addresses inequality and transport through a
                        detailed analysis of the variations in daily and long-distance travel
                        in Great Britain over a ten-year period. It is argued that there must be
                        a much wider interpretation of inequality– one that links actual travel
                        with measures of wellbeing and sustainability, recognizing that these will
                        change over time. Conclusions are drawn for policy makers and planners,
                        and public policy more generally.
                        <br>
                        The details are David Banister (2018) Inequality in Transport –
                         Price £30.00 – p. 272 and in full colour. ISBN 978-0-906661-01-7
                        <br>
                        See the book website -
                        <a href="www.inequalityintransport.org.uk" target="_blank">
                        www.inequalityintransport.org.uk</a> – there is
                        lots of information there and samples of what is in the book
                        - it is available through a variety of outlets, including amazon.
                        <br>
                        It is also available through amazon kindle
                        <a href="https://www.amazon.co.uk/dp/B07F2QMS6X/" target="_blank">
                        https://www.amazon.co.uk/dp/B07F2QMS6X/</a> price £9.99.
                      </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col align="center">
                    <v-img
                      src="../assets/img/david_banister.jpg"
                      width="210px"
                    />
                    </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        Currículo:
                        <br>Professor Emeritus of Transport Studies at Oxford University.
                         From 2006-2015 he was the Director of the Transport Studies Unit,
                         Oxford University and he was Director of the Environmental
                         Change Institute, also at Oxford University (2009-2010). Prior to 2006,
                         he was Professor of Transport Planning at University College London.
                         He has spent time as a Research Fellow at the Warren Centre in the
                         University of Sydney (2001-2002), a Visiting VSB Professor at the
                         Tinbergen Institute in Amsterdam (1994-1997) and Visiting Professor
                         at the University of Bodenkultur in Vienna in 2007. He was the first
                         Benelux BIVEC-GIBET Transport Chair (2012-2013) and he was recently the
                         Chair of the ERC Advanced Research Grants SH3 Panel (2015-2016). His
                         research expertise is in transport scenario building, sustainable cities,
                         energy and environmental modelling, and he has published 25 books and
                         over 300 papers in refereed journals on these topics.
                        <br><br>
                      </v-col>
                  </v-row>
                </v-container>

                <table width="100%">
                  <tr class="tituloPalestra">
                    <th class="bold">PALESTRA MAGNA <br>
                    08/04/2021 – 11h</th>
                  </tr>
                </table>

                <v-container>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: left"
                    class="bold"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>
                        Clima e Planejamento urbano<br>
                        Eleonora Sad de Assis<br>
                        Arquiteta e Urbanista, com ênfase em Adequação
                         Ambiental e professora da Universidade Federal de Minas Gerais
                      </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>As estruturas urbanas produzem uma alteração local do balanço de
                         energia de superfície, causando uma mudança no clima que pode influenciar
                         toda uma região, dependendo do tamanho da cidade. Os vários aspectos do
                         chamado clima urbano são hoje bem conhecidos e podem ser organizados nos
                         canais de percepção humana: conforto térmico, qualidade do ar e impacto
                         hidrometeórico (precipitações). Tais aspectos podem ser acentuados pelos
                         efeitos das mudanças climáticas globais no território da cidade,
                         demandando medidas de combate aos efeitos adversos do clima urbano, que
                         são de longo prazo. Assim sendo, tais medidas devem integrar os planos
                         diretores municipais e mesmo, os planos de ação climática dos estados e
                         municípios.<br>
                         Como não há soluções genéricas, principalmente num país com a diversidade
                         climática do Brasil, pretende-se colocar em discussão certas similaridades
                         (urbanas) e diferenças (climáticas) que poderiam conduzir a soluções
                         locais efetivas, a partir da aplicação de métodos e técnicas já
                         disponíveis da pesquisa em clima urbano.
                      </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col align="center">
                    <v-img
                      src="../assets/img/eleonora_sad.jpeg"
                      width="160px"
                    />
                    </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        Currículo:
                        <br>Graduada em Arquitetura e Urbanismo pela Universidade Federal
                         de Minas Gerais (1985), possui mestrado em Arquitetura pela Universidade
                         Federal do Rio de Janeiro (1990) e doutorado em Arquitetura e Urbanismo
                         pela Universidade de São Paulo (2000). Atualmente é Professora Associada
                         IV da Universidade Federal de Minas Gerais. Tem experiência na área de
                         Arquitetura e Urbanismo, com ênfase em Adequação Ambiental, atuando
                         principalmente nos seguintes temas: conforto ambiental, eficiência
                         energética, conforto térmico, clima urbano, planejamento e planejamento
                         urbano.
                        <br><br>
                      </v-col>
                  </v-row>
                </v-container>

                <table width="100%">
                  <tr class="tituloPalestra">
                    <th class="bold">PALESTRA SETORIAL <br>
                    09/04/2021 – 08h30 – Sala 1</th>
                  </tr>
                </table>

                <v-container>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: left"
                    class="bold"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>
                        Experiências de elaboração de políticas públicas para o turismo<br>
                        Renata Maria Ribeiro<br>
                        Professora Assistente da Universidade Estadual Paulista Júlio de
                         Mesquita Filho – UNESP
                      </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>As políticas públicas de Turismo se apresentam no Brasil em vários
                         momentos, entretanto, a partir da década de 1990 se caracterizam por
                         uma continuidade. No Estado de São Paulo a Lei 12.061/2015 provocou
                         uma nova conduta aos gestores de municípios turísticos ou que possuem
                         potencialidade para desenvolver a atividade. Em nossa palestra vamos
                         conversar sobre os Planos de Desenvolvimento Turístico realizados em
                         algumas cidades e sua contribuição para transformar recursos culturais
                         e naturais, em produto turístico.
                      </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col align="center">
                    <v-img
                      src="../assets/img/renata_maria.jpg"
                      width="170px"
                    />
                    </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        Currículo:
                        <br>Graduada em Turismo pela Universidade Federal do Paraná (1993),
                         Mestre em Geografia pela Universidade Federal do Paraná (2005) e Doutora
                         em Geografia pela Universidade Federal do Paraná (2011) na área de
                         Planejamento Urbano e Regional. Atualmente é professora assistente
                         doutora da Universidade Estadual Paulista Júlio de Mesquita Filho - UNESP.
                         Leciona e pesquisa nas áreas de Planejamento Territorial do Turismo,
                         Turismo no espaço urbano, Planejamento e políticas públicas de turismo,
                         hospitalidade e turismo, planejamento e plano diretor de cidades para o
                         turismo. Realizou os Planos Diretores desenvolvimento Turístico de
                         Panorama -SP, Pirapozinho - SP, Salmourão - SP entre outros.
                        <br><br>
                      </v-col>
                  </v-row>
                </v-container>

                 <table width="100%">
                  <tr class="tituloPalestra">
                    <th class="bold">PALESTRA SETORIAL <br>
                    09/04/2021 – 08h30 – Sala 2</th>
                  </tr>
                </table>

                <v-container>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: left"
                    class="bold"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>
                        Como oito cidades catarinenses desenvolveram juntas seus planos de
                         mobilidade<br>
                        Andrea Holz Pfutzenreuter, Simone Becker Lopes e Renata Cavion<br>
                        Professoras da Universidade Federal de Santa Catarina – UFSC
                      </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        <br>Quais ações municipais são necessárias para viabilizar a elaboração
                         dos Planos de Mobilidade Urbana (PMU)? As restrições orçamentárias e a
                         quantidade de servidores conseguirão gerenciar este processo? A
                         obrigatoriedade e o tempo disponível para a implementação são
                         oportunidades ou desafio?<br>
                        Nesse contexto, a palestra apresenta a experiência da Equipe da UFSC na
                         construção e execução da metodologia do Projeto PlanMob, que auxiliou
                         na estruturação dos planos de mobilidade em oito municípios de pequeno
                         porte simultaneamente. Enaltecendo a necessidade de vinculação entre
                         políticas de transporte e mobilidade destes municípios do nordeste
                         catarinense em decorrência dos fluxos resultantes pela interdependência
                         da infraestrutura viária disponível. A percepção das causas e
                         consequências à construção de diretrizes de desenvolvimento e de
                         planejamento urbano de forma conjunta.<br>
                        A sistematização das atividades foi dividida em oito etapas. A primeira
                         enfatiza a estruturação político-executiva do Município necessárias;
                         as seis etapas subsequentes elucidam o desenvolvimento do Plano de
                         Mobilidade Urbana; e a última etapa indica à elaboração da Carta de
                         Intenções do Plano de Mobilidade Regional.<br>
                        A metodologia proposta pela Equipe UFSC oportunizou a realização de
                         palestras e capacitações técnicas para o uso de ferramentas e técnicas
                         de planejamento e monitoramento da mobilidade urbana. Além do estímulo
                         da participação direta da população e de seus representantes na
                         formulação, execução e acompanhamento das atividades para ampliar a
                         consolidação do PMU.<br>
                        Alguns desafios para a equipe UFSC foram o tempo requerido para a
                         execução do projeto; o desenvolvimento simultâneos das etapas nos
                         municípios; e a participação como agentes executores de seus
                         próprios Planos de Mobilidade.<br>
                        O objetivo da condução do processo foi viabilizar a elaboração do
                         Plano de Mobilidade Urbana, e principalmente, permitir que a
                         revisão, continuidade e integração com o planejamento urbano seja
                         realizada pelos municípios com autonomia em qualquer época.<br>
                        A consolidação da proposta evidencia a prioridade aos transportes
                         ativos, vinculados aos transportes coletivo e escolar para o
                         planejamento do sistema viário e tráfego. O preceito de
                         identificar o uso e a ocupação do solo, preocupando-se com o meio
                         ambiente e patrimônio, conduziu a análise dos deslocamentos não
                         motorizados como atividade cotidiana necessária e salutar ao ser humano.
                        <br>
                      </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col align="center">
                    <v-img
                      src="../assets/img/andrea_holz.jpg"
                      width="160px"
                    />
                    </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        Currículo: Andrea Holz Pfutzenreuter<br>
                        <br>Professora adjunta na Universidade Federal de Santa Catarina, UFSC
                         Campus Joinville. Doutora em Arquitetura e Urbanismo pela Universidade
                         Mackenzie/SP, participou na Friedrich-Schiller-Universität em
                         Jena-Alemanha do grupo de pesquisa em Geografia Humana. Especialista em
                         Gerontologia pela Sociedade Brasileira de Geriatria e Gerontologia (SBGG).
                         Mestre em Habitação com ênfase em Planejamento, Gestão e Projeto pelo
                         Instituto de Pesquisa Tecnológicas de São Paulo (IPT 2008), especialista
                         em Gerontologia (UFSC 2010) e em Gestão de Projetos Sociais
                         (SENAC-SP 2006).
                      </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col align="center">
                    <v-img
                      src="../assets/img/simone_becker.jpg"
                      width="160px"
                    />
                    </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        Currículo: Simone Becker Lopes<br>
                        <br>Arquiteta e Urbanista e Mestre e Doutora em Planejamento e Operação
                         de Sistemas de Transportes pela USP – São Carlos, com Doutorado
                         Sanduíche no Institute of Transportation da Vienna University of
                         Technology. Trabalhou por 10 anos na EPTC (Empresa Pública de
                         Transportes e Circulação de Porto Alegre) com simulação de
                         tráfego, pesquisas e análise de dados de mobilidade e SIG (Sistemas de
                         Informações Geográficas). Tem experiência em consultorias para
                         administrações públicas municipais, na área de planos de transportes e
                         mobilidade e de gerenciamento de infraestrutura urbana, assim como para
                         administração pública federal como consultora em estudos de tráfego,
                         através da ONU, para atuar no PNUD (Plano das Nações Unidas para o
                         Desenvolvimento) de 2014 a 2015. Desde 2015, é professora na UFSC CT
                         Joinville na área de Planejamento de Transportes e Mobilidade, com
                         disciplinas e pesquisa ligadas a Planejamento Integrado de Transportes
                         e Uso do Solo, Análise de Demanda e Sistemas de Informações Geográficas.
                        <br>
                      </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col align="center">
                    <v-img
                      src="../assets/img/renata_cavion.jpg"
                      width="140px"
                    />
                    </v-col>
                  </v-row>
                  <v-row
                    justify="start"
                    no-gutters
                    style="text-align: justify"
                  >
                      <v-col
                        cols="24"
                      >
                        Currículo: Renata Cavion<br>
                        <br>Arquiteta e Urbanista (UNISINOS, 1999) com intercâmbio de graduação
                         no curso de Arquitetura da Universidad de Sevilla/Espanha (com bolsa
                         Intercampus ALE, 1997), Especialista em Geoprocessamento (UNISINOS, 2004),
                         Mestre em Engenharia Civil na área de Cadastro Técnico Multifinalitário e
                         Gestão Territorial (UFSC, 2008), Doutora em Ciências obtido no Programa
                         Geografia Física (USP, com bolsa da CAPES, 2014) realizando estágio
                         doutoral no Departamento de Arquitetura e Planificação Territorial
                         da Università di Bologna/Itália (com bolsa de Mobilidade Internacional
                         Santander, 2013). É Professora da Universidade Federal de Santa Catarina
                         - UFSC, no Departamento de Engenharias da Mobilidade desde 2013, onde
                         ministra disciplinas ligadas ao projeto e operação de terminais de
                         transporte, projeto arquitetônico e planejamento urbano. Foi coordenadora
                         do Projeto PlanMob (2015-2019) que auxiliou 8 municípios do Nordeste
                         Catarinense a desenvolverem simultaneamente seus planos de mobilidade.
                         Foi supervisora do Laboratório de Transportes e Logística (2018-2020).
                         Atualmente é Sub-chefe do Departamento de Engenharias da Mobilidade (EMB)
                         do Centro Tecnológico de Joinville (CTJ) da UFSC .
                        <br>
                      </v-col>
                  </v-row>
                </v-container>
                </div>

                  <!-- Programação -->
                  <div
                    v-show="idIndex === 2 && idPluris === 1"
                  >
                    <schedule />
                  </div>


                  <!-- Datas -->
                  <v-row
                    justify="center"
                    no-gutters
                    v-for="id in 10"
                    :key="id"
                  >
                    <v-col
                      cols="5"
                      v-show="idIndex === 0 && idPluris === 5"
                    >
                      <p
                        class="content date"
                        v-html="$t('content.items5[0].date' + id)"
                      />
                    </v-col>

                    <v-col
                      cols="7"
                      v-show="idIndex === 0 && idPluris === 5"
                    >
                      <p
                        class="content borderLeft"
                        v-html="$t('content.items5[0].title' + id)"
                      />
                    </v-col>
                  </v-row>

                  <!-- Datas Covid-19 -->
                  <p
                    class="content"
                    v-show="idIndex === 0 && idPluris === 5"
                    v-html="$t('content.items5[0].titleNewCall')"
                  />

                  <v-row
                    justify="center"
                    no-gutters
                    v-for="id in 2"
                    :key="id"
                  >
                    <v-col
                      cols="5"
                      v-show="idIndex === 0 && idPluris === 5"
                    >
                      <p
                        class="content date"
                        v-html="$t('content.items5[0].dateX' + id)"
                      />
                    </v-col>

                    <v-col
                      cols="7"
                      v-show="idIndex === 0 && idPluris === 5"
                    >
                      <p
                        class="content borderLeft"
                        v-html="$t('content.items5[0].titleX' + id)"
                      />
                    </v-col>
                  </v-row>

                  <!-- Inscrições -->
                  <div v-show="idIndex === 0 && idPluris === 4">

                  <table>
                  <tr>
                    <th>&nbsp;</th>
                    <th class="titleH" v-html="$t('content.items4[0].titleH1')" />
                    <th class="titleH" v-html="$t('content.items4[0].titleH2')" />
                  </tr>
                  <tr>
                    <th class="titleV"  v-html="$t('content.items4[0].titleV1')" />
                    <td>R$ 250,00</td>
                    <td>R$ 300,00</td>
                  </tr>
                  <tr>
                    <th class="titleV" v-html="$t('content.items4[0].titleV2')" />
                    <td>R$ 150,00</td>
                    <td>R$ 175,00</td>
                  </tr>
                  <tr>
                    <th class="titleV" v-html="$t('content.items4[0].titleV3')" />
                    <td>R$ 70,00</td>
                    <td>R$ 100,00</td>
                  </tr>
                </table>

                <p
                  class="content"
                  v-html="$t('content.items4[0].information')"
                />

                <p class="subscribe">
                  <a href="https://fundeb.org.br/pluris/" target="_blank">{{ $t('content.items4[0].subscribe') }}</a>
                </p>
                </div>


                  <!-- Notícias -->
                  <v-row
                    justify="center"
                    no-gutters
                    v-for="id in ids"
                    :key="id + 'news'"
                  >
                    <v-col
                      cols="12"
                      v-show="idIndex === 0 && idPluris === 6"
                    >
                      <p
                        class="content"
                      >
                        <span
                          v-html="$t('content.items6[0].date' + id)"
                        />
                        -
                        <span
                          v-html="$t('content.items6[0].title' + id)"
                        />
                        <v-dialog
                          v-model="dialog"
                          transition="dialog-bottom-transition"
                          scrollable
                          max-width="60%"
                          v-if="id === 19"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <a
                            v-bind="attrs"
                            v-on="on"
                          >
                            Clique aqui.
                          </a>
                        </template>
                        <v-card>
                          <v-toolbar
                            color="primary"
                            dark
                          ><b>Saiba como será o PLURIS 2021
                          totalmente digital!</b>
                          </v-toolbar>
                          <v-divider></v-divider>
                          <v-card-text style="height: 460px; padding: 20px; font-size: 16px;">
                            <p>Vem aí o 9° Congresso Luso-Brasileiro para o Planejamento Urbano,
                            Regional, Integrado e Sustentável (PLURIS 2021 DIGITAL)!</p>
                            <p>Devido à pandemia causada pelo novo coronavírus, desta vez,
                            o PLURIS será totalmente digital.</p>
                            <p>Para uma melhor experiência dos congressistas, utilizaremos
                            uma plataforma digital que proporcionará um ambiente de discussão
                            e interação entre congressistas e palestrantes, de
                            qualquer lugar do mundo.</p>
                            <p>De 07 à 09 de abril de 2021, o PLURIS 2021 contará
                            com atividades muito similares à versão presencial e os
                            congressistas poderão explorar quatro ambientes diferentes:</p>
                            <p><b>Sessões técnicas:</b> ambiente onde estarão disponíveis, em
                            forma de vídeo, os 260 trabalhos aprovados no congresso.
                            Eles poderão ser acessados a qualquer momento, pois estarão
                            expostos de forma assíncrona, de 07 de abril à 07 de junho
                            de 2021.
                            </p>
                            <p><b>Atividades <i>on line</i>:</b> ambiente onde serão apresentadas
                            as atividades síncronas, tais como palestras e painéis temáticos,
                            contando com a valorosa contribuição de especialistas
                            nacionais e internacionais.
                            </p>
                            <p><b><i>Lounge</i> virtual:</b> ambiente onde os participantes
                            poderão interagir entre si e com a organização do evento, via
                            <i>chat</i>.
                            </p>
                            <p><b>Feira virtual:</b> os patrocinadores do PLURIS 2021 poderão
                            expor seus produtos por meio de vídeos, fotos e catálogos.
                            Também poderão interagir com os congressistas via <i>e-mail</i>,
                            fórum, <i>chat</i> ou até mesmo via <i>live</i>.
                            </p>
                          </v-card-text>
                          <v-divider></v-divider>
                        </v-card>
                        </v-dialog>

                        <v-dialog
                          v-model="dialog"
                          transition="dialog-bottom-transition"
                          scrollable
                          max-width="60%"
                          v-else-if="id === 20"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <a
                            v-bind="attrs"
                            v-on="on"
                          >
                            Clique aqui.
                          </a>
                        </template>
                        <v-card>
                          <v-toolbar
                            color="primary"
                            dark
                          ><b>O PLURIS 2021 DIGITAL está chegando e,
                          com ele, muitas novidades!</b>
                          </v-toolbar>
                          <v-divider></v-divider>
                          <v-card-text style="height: 400px; padding: 20px; font-size: 16px;">
                            <p>Agora que vocês já sabem que nos encontraremos por meio de uma
                            plataforma digital, vamos explicar como será a programação
                            científica do evento.</p>
                            <p>As tradicionais “Sessões Técnicas” estarão disponíveis
                            de forma assíncrona, na plataforma do evento, de 07 de abril
                            a 07 de junho. Os trabalhos dessas sessões serão
                            apresentados na forma de vídeo. </p>
                            <p>Os Anais do PLURIS 2021 estarão disponíveis em nosso site
                            (https://pluris2020.faac.unesp.br), a partir de 07 abril.
                            </p>
                            <p>As palestras serão apresentadas de forma síncrona e vocês
                            poderão interagir com os palestrantes via <i>chat</i>, o que
                            proporcionará uma maior interação entre todos os
                            envolvidos.</p>
                            <p>Visando priorizar o perfil acadêmico do evento, nesta
                            edição teremos os “Painéis Temáticos”, que será uma atividade
                            síncrona, disponibilizada em horários específicos e
                            será composta por alguns dos melhores trabalhos
                            do congresso, aderentes a temas importantes na atualidade.
                            </p>
                            <p>Vale a pena consultar a programação!
                            </p>
                          </v-card-text>
                          <v-divider></v-divider>
                        </v-card>
                        </v-dialog>

                        <v-dialog
                          v-model="dialog"
                          transition="dialog-bottom-transition"
                          scrollable
                          max-width="50%"
                          v-else-if="id === 22"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <a
                            v-bind="attrs"
                            v-on="on"
                          >
                            Clique aqui.
                          </a>
                        </template>
                        <v-card>
                          <v-toolbar
                            color="primary"
                            dark
                          ><b>Nota de Falecimento Profa Júlia Lourenço</b>
                          </v-toolbar>
                          <v-divider></v-divider>
                          <v-card-text style="height: 560px; padding: 20px; font-size: 16px;"
                          class="justify-center">
                            <p>O PLURIS expressa uma profunda tristeza pelo falecimento da
                            Professora Júlia Lourenço, Professora de Urbanismo e Planeamento
                            Urbano do Departamento de Engenharia Civil da UMinho, e sempre
                            ligada à realização do PLURIS conjuntamente com os Colegas da
                            UMinho. A Professora Júlia Lourenço partiu muito cedo e deixa
                            um legado enorme  face à sua bondade e às admiráveis qualidades
                            pessoais e profissionais. Será sempre recordada pela sua
                            generosidade, energia, criatividade e partilha de conhecimentos.
                            A toda a sua Família, Colegas e Amigos, os votos de sentidas
                            condolências neste momento de Dor e Tristeza.</p>
                            <v-row justify="center">
                              <v-col align="center">
                              <v-img
                                src="../assets/img/julia_lourenco.jpg"
                                width="250px"
                              />
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-divider></v-divider>
                        </v-card>
                        </v-dialog>

                        <a
                          @click="changePageInside(id)"
                          v-else-if="$t('content.items6[0].link') !== ''"
                        >
                          {{ $t('content.items6[0].link' + id) }}
                        </a>

                        <span
                          v-if="id === 4"
                          v-html="$t('content.items6[0].extension4')"
                        />
                      </p>
                    </v-col>
                  </v-row>
                </div>

                <v-col
                  cols="12"
                  class="footer"
                >

                <v-row no-gutters>
                  <v-col
                      cols="5"
                    >
                      <v-card
                        class="pa-1 mt-3"
                        outlined
                        tile
                      >
                        <p class="textFooter">
                          <b>9° Congresso Luso-Brasileiro</b><br>
                          para o Planejamento Urbano,
                          Regional, Integrado e Sustentável.
                        </p>
                      </v-card>
                    </v-col>

                    <v-col
                      cols="4"
                    >
                      <v-card
                        class="pa-1 mt-3"
                        outlined
                        tile
                      >
                        <p class="textIcon">pluris2020@unesp.br</p>
                        <p class="textIcon">+55 14 31034826</p>
                      </v-card>
                    </v-col>

                    <v-col
                      cols="1"
                    >
                      <v-card
                        class="pa-1 mt-3"
                        outlined
                        tile
                      >
                        <a
                          href="https://www.instagram.com/pluriscongresso/"
                          target="_blank"
                        >
                        <v-img
                            src="../assets/img/instagram.png"
                            height="30px"
                            contain
                          />
                        </a>
                      </v-card>
                    </v-col>

                    <v-col
                      cols="1"
                    >
                      <v-card
                        class="pa-1 mt-3"
                        outlined
                        tile
                      >
                       <a
                          href="https://www.facebook.com/pluris.congresso"
                          target="_blank"
                        >
                        <v-img
                            src="../assets/img/facebook.png"
                            height="30px"
                            contain
                          />
                        </a>
                      </v-card>
                    </v-col>
                 </v-row>

                  <v-row
                    justify="start"
                  >
                    <v-col
                      cols="5"
                    >
                      <p
                        class="textFooter"
                      >
                        <b>{{ $t("content.items1[1].title1") }}</b>
                      </p>

                      <v-row
                        justify="start"
                        no-gutters
                      >
                        <v-col
                          cols="11"
                        >
                          <v-img
                            src="../assets/img/uminho_usp_ufscar.png"
                          />
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col
                      cols="7"
                    >
                      <p
                        class="textFooter"
                      >
                        <b>{{ $t("content.items1[1].title2") }}</b>
                      </p>

                      <v-row
                        justify="start"
                        no-gutters
                      >
                        <v-col
                          cols="3"
                        >
                          <v-img
                            src="../assets/img/unesp.svg"
                          />
                        </v-col>

                        <v-col
                          cols="2"
                        >
                          <v-img
                            src="../assets/img/PPGARQ_h.png"
                          />
                        </v-col>

                        <v-col
                          cols="3"
                        >
                          <v-img
                            src="../assets/img/civil.png"
                          />
                        </v-col>

                        <v-col
                          cols="2"
                        >
                          <v-img
                            src="../assets/img/faac.jpg"
                          />
                        </v-col>

                        <v-col
                          cols="2"
                        >
                          <v-img
                            src="../assets/img/feb.jpg"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
          </v-card>
      </v-row>
  </v-container>
</template>

<script>
import MenuPluris from './MenuPluris.vue';
import Schedule from './Schedule.vue';

export default {
  name: 'CardPluris',
  data: () => ({
    title: '',
    content: 'content.items1[0].text',
    idPluris: -1,
    idIndex: -1,
    ids: [28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14,
      13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
  }),
  components: {
    MenuPluris,
    Schedule,
  },
  methods: {
    callPageCard({ id, index }) {
      let pageTitle;
      this.idPluris = id;
      this.idIndex = index;

      if (id === 1 || id === 3) {
        pageTitle = `menu.items${id}[${index}].title`;
      } else {
        pageTitle = `menu.item${id}`;
      }

      const pageContent = `content.items${id}[${index}].text`;

      this.title = this.$i18n.t(pageTitle);
      this.content = this.$i18n.t(pageContent);
    },
    callInitialPage() {
      this.$router.push({ name: 'home' });
    },
    changePageInside(pageId) {
      const array = this.$i18n.t(`content.items6[0].coord${pageId}`);
      const id = array[0];
      const index = array[1];

      this.callPageCard({ id, index });
    },
  },
  created() {
    this.title = this.$i18n.t('menu.items1[0].title');

    this.callPageCard({ id: 6, index: 0 });
  },
};
</script>

<style scoped>
.container {
  padding: 0 !important;
}

.cardPluris {
  width: 70vw;
  background-color: transparent;
}

.rowMenu {
  padding-left: 1vw;
  padding-right: 1vw;
  padding-top: 1.5vw;
  padding-bottom: 2vw;
}

.divider {
  background-color: var(--v-tertiary-base);
  border-width: 1px;
  opacity: 0.2;
}

.content {
  text-align: start;
}

.titlePluris {
  text-align: start;
  color: var(--v-tertiary-base);
  font-weight: 700;
  font-size: 25px;
}

.subscribe {
  text-align: center;
  color: var(--v-tertiary-base);
  font-weight: 700;
  font-size: 25px;
}

.cardContent {
  height: 90vh;
}

.scrollbar {
  padding-left: 8vh;
  padding-right: 5vh;
  line-height: 22px;
  padding-top: 3vh;
  height: 68vh;
  overflow-y: auto;
  max-width: 100%;
  overflow-x: hidden;
}

.scrollbar::-webkit-scrollbar {
  background-color: rgb(245, 155, 50, 0.25);
  width: 4px;
  border-radius: 5px;
}

.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgb(245, 155, 50, 1);
}

.cardImage {
  margin-right: 2vw;
  margin-top: 2vw;
  padding: 2vw;
  cursor: pointer;
}

.footer {
  padding-left: 8vh;
  padding-top: 1vh;
}

.textFooter {
  color: #939598;
  font-size: 14px;
  text-align: start;
  margin-bottom: 0px;
}

.textIcon {
  color: #939598;
  font-size: 14px;
  text-align: start;
}

.responsiveFrame {
  width: 35vw;
  height: 50vh;
}

.responsiveFrameYoutube {
  width: 35vw;
  height: 40vh;
  margin-bottom: 10px;
}

.borderLeft {
  border-left: 1.25px solid black;
  padding-left: 10px;
  margin-left: 10px;
}

.date {
  color: var(--v-primary-base);
}

.contentEnd {
  text-align: end;
}

/* Table */

table{
  border-spacing: 0px;
}

th, td {
  border-right: 0.5px solid black;
  border-bottom: 0.5px solid black;
  padding: 10px;
  font-weight: normal;
}

td {
  font-weight: bold;
}

.titleH {
  border-top: 0.5px solid black;
}

.titleV {
  border-left: 0.5px solid black;
}

.theme--light.v-card.v-card--outlined {
  border: 0px !important;
}

.tituloPalestra {
  background-color: #2f5496;
  color: white;
}

.bold {
  font-weight: 700;
}
</style>
